// eslint-disable-next-line no-undef
require('core-js/stable');
// eslint-disable-next-line no-undef
require('regenerator-runtime/runtime');
